import {
    CREATE_BIKE_HPI_CHECK,
    CREATE_BIKE_HPI_CHECK_SUCCESS,
    CREATE_BIKE_HPI_CHECK_FAILURE,

    GET_BIKE_HPI_CHECK,
    GET_BIKE_HPI_CHECK_SUCCESS,
    GET_BIKE_HPI_CHECK_FAILURE,
} from '../constants/bike_hpi_check.constants';


export const createBikeHpiCheckRequest = bike_id => ({
    type: CREATE_BIKE_HPI_CHECK, bike_id,
});

export const createBikeHpiCheckSuccess = data => ({
    type: CREATE_BIKE_HPI_CHECK_SUCCESS, data,
});

export const createBikeHpiCheckFailure = error => ({
    type: CREATE_BIKE_HPI_CHECK_FAILURE, error,
});


export const getBikeHpiCheckRequest = bike_id => ({
    type: GET_BIKE_HPI_CHECK, bike_id,
});

export const getBikeHpiCheckSuccess = payload => ({
    type: GET_BIKE_HPI_CHECK_SUCCESS, payload,
});

export const getBikeHpiCheckFailure = error => ({
    type: GET_BIKE_HPI_CHECK_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/bike_hpi_check.actions.js